import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiPost, apiPatch } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

// Fetches every non-SOD analytic the current user has section access to
// for the current municipality, joined to the monitoring_analytics rows so
// each entry carries its current is_control state.
export function useMonitoringAnalytics({ options = {} } = {}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)

  return useQuery(
    ['monitoring-analytics', municipality_id],
    () =>
      apiGet({
        url: `municipalities/${municipality_id}/monitoring_analytics`,
        token
      }),
    { staleTime: 60 * 1000, ...options }
  )
}

// Upsert toggle. If the row already exists, PATCH it; otherwise POST a new
// row under the municipality. On success, invalidates everything the
// monitoring page reads so the new classification is reflected immediately.
export function useUpdateMonitoringAnalytic({ options = {} } = {}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryClient = useQueryClient()

  return useMutation(
    async ({ id, analyticId, isControl }) => {
      if (id) {
        return apiPatch({
          url: `monitoring_analytics/${id}`,
          token,
          objectName: 'monitoring_analytic',
          params: { is_control: isControl }
        })
      }
      return apiPost({
        url: `municipalities/${municipality_id}/monitoring_analytics`,
        token,
        objectName: 'monitoring_analytic',
        params: { analytic_id: analyticId, is_control: isControl }
      })
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['monitoring-analytics'])
        queryClient.invalidateQueries(['monitoring-control-analytics'])
        queryClient.invalidateQueries(['analytics-monitoring'])
        queryClient.invalidateQueries(['analytics-monitoring-transactions'])
        queryClient.invalidateQueries(['monitoring-high-risk-transactions'])
        if (options.onSuccess) options.onSuccess(data, variables, context)
      }
    }
  )
}
